import type { TpePaymentStatus } from "cadendar-shared";

export const statusLabels: Record<TpePaymentStatus, string> = {
  pending: "En attente",
  approved: "Approuvé",
  manually_recorded: "Saisi manuellement",
  not_completed: "Non abouti",
  unknown: "Incident",
};

export const statusBadgeClasses: Record<TpePaymentStatus, string> = {
  pending: "bg-amber-100 text-amber-800",
  approved: "bg-green-100 text-green-800",
  manually_recorded: "bg-blue-100 text-blue-800",
  not_completed: "bg-gray-100 text-gray-700",
  unknown: "bg-red-100 text-red-800",
};

export const formatMoneyCents = (value: number) =>
  `${(value / 100).toFixed(2).replace(".", ",")} €`;

export const formatSettledCount = (count: number) =>
  count === 1 ? "1 règlement encaissé" : `${count} règlements encaissés`;

export const isSettledTpePayment = (status: TpePaymentStatus) =>
  status === "approved" || status === "manually_recorded";
